/**
 * @Author:
 * @Description:
 * @DateTime: Created in 2021-03-24 22:56:12
 */

import * as Vue from 'vue-tsx-support';
import { Component, Prop } from 'vue-property-decorator';
import 'vue-tsx-support/enable-check';
import Modal from 'src/types/iview/Modal';
import Button from 'src/types/iview/Button';
import Input from 'src/types/iview/Input';
import { Toast } from 'src/util/toast';
import { modalFactory } from 'src/util/vueExtend';
import EnumOperates from 'src/enums/enumOperates';
import { Integer } from 'src/types/base';
import { createNamespace } from 'src/util/bem';
import { EnumCompareTaskConfirmStatus, EnumCompareTaskDealStatus } from 'src/enums/enumCompareTaskStatus';
import CommonSelect from 'src/components/SelectCustom/commonSelect';
import EntitySelect from 'src/components/SelectCustom/entitySelect';
import EnumEntity from 'src/enums/enumEntity';
import ExceptionTaskApi from './api/exceptionTaskApi';
import { EnumExceptionTaskDealStatus } from 'src/enums/enumExceptionStatus';

export namespace OperateExceptionTaskVOI {
    export interface PropsI {
        operate: string;
        id: number;
        device_id: number;

        saveSuccess?(): void;

        cancel?(): void;
    }

    export interface FormDataI {
        device_name: string;
        dispose_condition: Integer;
        dispose_explain: string;
        inform_number: string;
        initiator: string;
        operational_content: string;
        operational_equipment: string[];
        sponsor_datetime: string;
        task_number: string;
        user_id: Integer;
    }

    export interface OperateFormDataI {
        affirm_cause: string;
        affirm_condition: Integer;
        user_id: Integer;
        dispose_explain: string;
    }
}

@Component
class OperateExceptionTaskModal extends Vue.Component<OperateExceptionTaskVOI.PropsI> {
    @Prop({
        type: Function,
    })
    cancel!: () => void;

    @Prop({
        type: Number,
    })
    id!: number;

    @Prop({
        type: Number,
    })
    device_id!: number;

    @Prop({
        type: String,
    })
    operate!: string;

    @Prop({
        type: Function,
    })
    saveSuccess!: () => void;

    visible: boolean = false;

    loading: boolean = false;

    formData: OperateExceptionTaskVOI.FormDataI = {
        device_name: '',
        dispose_condition: null,
        dispose_explain: '',
        inform_number: '',
        initiator: '',
        operational_content: '',
        operational_equipment: [],
        sponsor_datetime: '',
        task_number: '',
        user_id: null,
    };

    operateForm: OperateExceptionTaskVOI.OperateFormDataI = {
        user_id: null,
        affirm_cause: '',
        affirm_condition: null,
        dispose_explain: '',
    };

    rules: any = {
        name: [{ required: true, message: '请输入名称', trigger: 'change' }],
    };

    close() {
        this.cancel && this.cancel();
        this.closeModal();
    }

    closeModal() {
        this.visible = false;
        this.$emit('close', false);
    }

    async save() {
        if (!(await this.$validate('formValidate'))) {
            return;
        }
        if (this.operateForm.affirm_condition === EnumCompareTaskConfirmStatus.现场条件不允许.getId() && !this.operateForm.affirm_cause) {
            return Toast.error('请填写原因');
        }
        let res;
        this.loading = true;
        switch (this.operate) {
            case EnumOperates.Distribute.getName():
                res = await ExceptionTaskApi.distribute({
                    id: this.id,
                    device_id: this.device_id,
                    user_id: this.operateForm.user_id,
                });
                break;
            case EnumOperates.Deal.getName():
                res = await ExceptionTaskApi.dispose({
                    id: this.id,
                    device_id: this.device_id,
                    dispose_explain: this.operateForm.dispose_explain,
                });
                break;
        }
        this.loading = false;
        let { code } = res;
        if (code === 0) {
            Toast.success(this.operate + '成功');
            this.saveSuccess();
            this.closeModal();
        }
    }

    async mounted() {
        let { code, data } = await ExceptionTaskApi.searchDetail({ id: this.id, device_id: this.device_id });
        if (code === 0) {
            this.formData = {
                ...data,
                user_id: null,
            };
        }
    }

    render(h) {
        return (
            <Modal
                title={'异常任务' + this.operate}
                width="1000"
                v-model={this.visible}
                mask-closable={false}
                on-on-cancel={this.close}
                footer-hide={this.operate === EnumOperates.Detail.getName()}
            >
                <i-form ref="formValidate" labelWidth={100} class={createNamespace('detail-form')} model={this.operateForm}>
                    <form-item labelWidth={80} label="通知单号：" style="display: inline-block;width:30%">
                        {this.formData.inform_number}
                    </form-item>
                    <form-item labelWidth={80} label="任务单号：" style="display: inline-block;width:30%">
                        {this.formData.task_number}
                    </form-item>
                    <form-item labelWidth={80} label="发起人" style="display: inline-block;width:20%">
                        {this.formData.initiator}
                    </form-item>
                    <form-item labelWidth={80} label="发起时间" style="display: inline-block;width:20%">
                        {this.formData.sponsor_datetime}
                    </form-item>
                    <form-item label="异常站点：" style="display: inline-block;width:90%" class={createNamespace('mt15')}>
                        {this.formData.device_name}
                    </form-item>
                    <form-item label="异常设备：" style="display: inline-block;width:90%">
                        {(this.formData.operational_equipment || []).join('、')}
                    </form-item>
                    <form-item label="异常内容：" style="display: inline-block;width:90%">
                        {this.formData.operational_content}
                    </form-item>
                    <div class={createNamespace('mt15')} v-if={EnumExceptionTaskDealStatus.已处理.getId()===this.formData.dispose_condition}>
                        <form-item label="处理情况：" style="display: inline-block;width:30%" >
                            {EnumCompareTaskDealStatus.findId(this.formData.dispose_condition).getName()}
                        </form-item>
                        <form-item label="处理原因：" style="display: inline-block;width:60%" >
                            {this.formData.dispose_explain}
                        </form-item>
                    </div>
                    <form-item
                        label="确认："
                        style="width:45%;margin-top:15px;"
                        v-if={this.operate === EnumOperates.Confirm.getName()}
                        required
                        type="number"
                        prop="affirm_condition"
                    >
                        <CommonSelect dataSource={EnumCompareTaskConfirmStatus.getList()} v-model={this.operateForm.affirm_condition} />
                    </form-item>
                    <form-item
                        label="原因："
                        style="width:45%"
                        v-if={
                            this.operate === EnumOperates.Confirm.getName() &&
                            this.operateForm.affirm_condition === EnumCompareTaskConfirmStatus.现场条件不允许.getId()
                        }
                    >
                        <Input placeholder="请输入" v-model={this.operateForm.affirm_cause} type="textarea" />
                    </form-item>
                    <form-item
                        v-if={this.operate === EnumOperates.Distribute.getName()}
                        label="处理人"
                        prop="user_id"
                        required
                        type="number"
                        style="width:45%;margin-top:15px;"
                    >
                        <EntitySelect type={EnumEntity.User.getId()} v-model={this.operateForm.user_id} />
                    </form-item>
                    <form-item
                    class={createNamespace('mt15')}
                        label="处理说明："
                        style="width:45%"
                        prop="dispose_explain"
                        required
                        v-if={this.operate === EnumOperates.Deal.getName()}
                    >
                        <Input placeholder="请输入" v-model={this.operateForm.dispose_explain} type="textarea" />
                    </form-item>
                </i-form>
                <div slot="footer">
                    <Button type="primary" ghost on-click={this.close}>
                        取消
                    </Button>
                    <Button type="primary" on-click={this.save} loading={this.loading}>
                        保存
                    </Button>
                </div>
            </Modal>
        );
    }
}

export default function alertOperateExceptionTaskModal(operate: string, id: number, device_id: number): Promise<boolean> {
    return new Promise((resolve, reject) => {
        modalFactory<OperateExceptionTaskVOI.PropsI>(OperateExceptionTaskModal)({
            id,
            operate,
            device_id,
            saveSuccess() {
                resolve(true);
            },
            cancel() {
                resolve(false);
            },
        });
    });
}
